'use client';

import { useSystemLabels } from '@eliadmin/core/src/hooks/use-system-labels';
import { CartBadge } from '@eliadmin/core/src/components/header/cart-badge';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useCartQueryOpts } from '@eliadmin/core/src/hooks/cart/use-cart';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useQuery } from '@tanstack/react-query';
import Link from '@eliadmin/core/src/components/link';
import { MdOutlineShoppingCart } from 'react-icons/md';

export function HeaderCartButton() {
  const systemLabels = useSystemLabels();
  const { t } = useTranslations();

  useQuery({ ...useCartQueryOpts() });

  return (
    <Button asChild variant={'none'} size={'none'}>
      <Link aria-label={systemLabels('cart')} href={ROUTES.CART()} prefetchOnHover>
        <div className="relative">
          <CartBadge />
          <MdOutlineShoppingCart size={20} className="text-black" />
        </div>
        {t('text343')}
      </Link>
    </Button>
  );
}
